import CustomDatePickerUd from "../components/CustomDateTimePickerUD";
import {
  approval_status_column_properties,
  approval_ud_date_column_properties,
  ud_status_column_properties,
} from "./udCommanColumnProperties";
import { Render_ud_status_cell } from "./udGridCustomCell";

const convert_dd_mm_yy_to_Date = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/")?.map((d) => parseInt(d));
  return new Date(yy, mm - 1, dd);
};
// const date_time_string_to_date = (date_time_string) => {
//   // console.log({ date_time_string, d: new Date(date_time_string) });
//   return new Date(date_time_string);
// };

const date_column_properties = {
  type: "dateTime",
  valueGetter: ({ value }) => {
    // console.log(value);
    if (typeof value === "object") return value;
    return value && convert_dd_mm_yy_to_Date(value);
  },
};

export const udGridColumns = {
  // "s.no.": {
  //   "name": "s.no.",
  //   "type": "number",
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "s.no.",
  //   "headerName": "S.NO.",
  //   "width": 75
  // },
  product_id: {
    name: "product_id",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "Product ID",
    headerName: "PRODUCT ID",
    width: 200,
  },
  product_name: {
    name: "product_name",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "product_name",
    headerName: "PRODUCT NAME",
    width: 200,
  },
  batch_number: {
    name: "batch_number",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "batch_number",
    headerName: "BATCH NUMBER",
    width: 200,
  },
  // "pack": {
  //   "name": "pack",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "pack",
  //   "headerName": "PACK"
  // },
  // "condition_/_stage": {
  //   "name": "condition_/_stage",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "condition_/_stage",
  //   "headerName": "CONDITION / STAGE"
  // },
  // "due_date": {
  //   "name": "due_date",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "due_date",
  //   "headerName": "QC RECEIVE DATE",
  //   ...approval_ud_date_column_properties,
  //   width: 200,
  // },
  market: {
    name: "market",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "market",
    headerName: "MARKET",
    width: 200,
  },
  interval: {
    name: "interval",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "spec_id",
    headerName: "SPEC ID",
    width: 200,
  },
  // "no._of_days_left_for_completion_of_analysis": {
  //   "name": "no._of_days_left_for_completion_of_analysis",
  //   "type": "number",
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "no._of_days_left_for_completion_of_analysis",
  //   "headerName": "NO. OF DAYS LEFT FOR COMPLETION OF ANALYSIS",
  //   "width": 200
  // },
  // "targeted_date_for_completion_of_analysis": {
  //   "name": "targeted_date_for_completion_of_analysis",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "targeted_date_for_completion_of_analysis",
  //   "headerName": "TARGETED DATE FOR COMPLETION OF ANALYSIS",
  //   "width": 300,
  //   ...approval_ud_date_column_properties,
  // },
  completion_date: {
    name: "completion_date",
    type: null,
    isDate: true,
    isSelect: false,
    isText: false,
    needsDateInput: true,
    visible: true,
    editable: false,
    field: "Completion Date",
    headerName: "QC COMPLETION DATE",
    ...approval_ud_date_column_properties,
    // renderCell: render_date_picker,
    width: 200,
  },
  // "completed_within__(in_days)": {
  //   "name": "completed_within__(in_days)",
  //   "type": "number",
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "field": "completed_within__(in_days)",
  //   "headerName": "COMPLETED WITHIN  (IN DAYS)",
  //   renderCell: render_alert_cell,
  //   width: 200,
  // },
  // "data_shared_on": {
  //   "name": "data_shared_on",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "field": "data_shared_on",
  //   "headerName": "DATA SHARED ON",
  //   status: false,
  // },
  // "remarks": {
  //   "name": "remarks",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": true,
  //   "isText": false,
  //   "needsDateInput": false,
  //   "visible": true,
  //   "editable": false,
  //   "select_options": "remark_status",
  //   "field": "remarks",
  //   "headerName": "REMARKS",
  //   ...reviewer_remark_status_column_properties,
  //   // renderCell: render_remarks_cell,
  //   width: 200,
  // },
  age: {
    name: "age",
    type: "number",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    field: "age",
    headerName: "AGE",
    width: 100,
  },
  ud: {
    name: "ud",
    type: "text",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    field: "ud",
    headerName: "UD",
    width: 150,
  },
  // "id": {
  //   "name": "id",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": false,
  //   "field": "id",
  //   "headerName": "ID"
  // },
  approval: {
    name: "approval",
    // "type": "boolean",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: false,
    field: "approval",
    headerName: "QA QC Approval",
    ...approval_status_column_properties,
    // renderCell: Render_approval_status_cell,
    width: 200,
  },
  // "approval_date": {
  //   "name": "approval_date",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": false,
  //   "field": "approval_date",
  //   "headerName": "APPROVAL DATE",
  //   ...approval_ud_date_column_properties,
  //   // renderCell: render_approval_ud_date_picker,
  //   width: 150,
  // },
  ud_remark: {
    name: "ud_remark",
    // "type": null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: false,
    field: "UD remark",
    headerName: "UD APPROVAL",
    ...ud_status_column_properties,
    renderCell: Render_ud_status_cell,
    width: 180,
  },
  document_received_date: {
    field: "document_received_date",
    headerName: "Document Received Date",
    visible: true,
    editable: false,
    width: 220,
    ...date_column_properties,
    renderCell: CustomDatePickerUd,
  },
  // "ud_date": {
  //   "name": "ud_date",
  //   "type": null,
  //   "isDate": false,
  //   "isSelect": false,
  //   "isText": true,
  //   "needsDateInput": false,
  //   "visible": false,
  //   "field": "ud_date",
  //   "headerName": "UD DATE",
  //   ...approval_ud_date_column_properties,
  //   // renderCell: render_approval_ud_date_picker,
  //   width: 100,
  // },
};
